<template>
  <a-drawer
    v-model:visible="drawVisible"
    class="custom-class"
    width="420"
    :bodyStyle="{ maxHeight: '90%' }"
    :title="
      `${addOrEdit === 1 ? '创建' : '编辑'}${
        menuType === 1
          ? '一'
          : menuType === 2
          ? '二'
          : menuType === 3
          ? '三'
          : '四'
      }级${menu.menuModule === 2 ? '政策' : ''}菜单`
    "
    placement="right"
    :maskClosable="false"
  >
    <a-tabs v-model:activeKey="langCode" v-if="langDic && langDic.length">
      <a-tab-pane v-for="item in langDic" :key="item.value" :tab="item.label">
        <div
          v-if="
            menu.menuModule === 1 &&
              postParams.navType === 'header' &&
              menuType === 2 &&
              postParams.subChannel === 2
          "
        >
          <div><span class="red">*</span>二级菜单类别：</div>
          <div class="mb10">
            <a-radio-group
              v-model:value="menu.menuCategory"
              :disabled="langCode !== langDic[0].value || addOrEdit === 2"
              @change="e => changemenuCategory(e, menu, langDic)"
            >
              <a-radio :value="1">普通二级菜单</a-radio>
              <a-radio :value="2">广告位</a-radio>
            </a-radio-group>
          </div>
        </div>
        <div v-if="menuType === 2 && menu.menuCategory === 2">
          <div><span class="red">*</span>选择位置：</div>
          <div class="mb10">
            <a-radio-group
              v-model:value="menu.bannerType"
              :disabled="langCode !== langDic[0].value || addOrEdit === 2"
              @change="changeBannerType(langDic)"
            >
              <a-radio :value="1">header导航头部</a-radio>
              <a-radio :value="2">header导航尾部</a-radio>
            </a-radio-group>
          </div>
          <div><span class="red">*</span>名称：</div>
          <div class="mb10">
            <a-input
              v-model:value="item.menuName"
              placeholder="请输入名称"
              @change="
                () =>
                  inputLengthCut(
                    {
                      val: item.menuName,
                      type: 2,
                      menuModule: 2
                    },
                    item
                  )
              "
            />
          </div>
          <div>
            <span class="red">*</span>上传图片：支持png、jpg格式上传，最大500kb
          </div>
          {{ menu.bannerType - 0 === 1 ? `尺寸：295*80` : `尺寸：295*148` }}
          <div class="mb10 mt10">
            <a-upload
              list-type="picture"
              :beforeUpload="
                e =>
                  beforeUpload(
                    e,
                    item,
                    langCode !== langDic[0].value,
                    langDic,
                    menu.bannerType
                  )
              "
              :accept="
                'image/png,image/jpeg,image/webp,image/gif,image/svg+xml,.png,.jpg,.jpeg,.gif,.webp,.bmp,.svg'
              "
              :showUploadList="false"
            >
              <a-button
                :disabled="item.menuPicDtos?.length >= 3"
                v-if="langCode === langDic[0].value"
              >
                <upload-outlined></upload-outlined>
                上传图片
              </a-button>
            </a-upload>

            {{ item.menuPicDtos?.map(item => item.picName)?.join(',') }}
          </div>
          <template v-if="item.menuPicDtos?.length >= 3">
            <a-button
              style="margin-top:10px;display: inline-flex"
              type="primary"
              disabled
              >素材选择</a-button
            >
          </template>
          <template v-else>
            <MaterialSelectionListModal
              v-if="langCode === langDic[0].value"
              style="margin-top:10px;display: inline-flex"
              @submit="
                val =>
                  handleUpdateResourceMateral(
                    val,
                    item,
                    -1,
                    langCode !== langDic[0].value,
                    langDic
                  )
              "
              :validateImageOrVideoArea="[
                menu.bannerType - 0 === 1 ? `295*80` : `295*148`
              ]"
              :title="menu.bannerType - 0 === 1 ? '素材选择' : '素材选择'"
              :validateImageOrVideoFormatAndSizeByMB="{
                jpg: 5,
                png: 5,
                gif: 10,
                jpeg: 5,
                'image/png': 5,
                'image/gif': 10,
                'image/jpeg': 5,
                'image/jpg': 5
              }"
              :fileterResourceType="1"
              :siteId="Number(postParams.siteId)"
              :subTerminalId="getSubTerminalId()"
            >
              <template #trigger>
                <a-button style="margin-left: 10px;" type="primary">
                  {{
                    menu.bannerType - 0 === 1
                      ? '素材选择 (295*80)'
                      : '素材选择 (295*148)'
                  }}
                </a-button>
              </template>
            </MaterialSelectionListModal>
          </template>
          <div style="color: red">支持最多上传三张图片</div>
          <div>预览：</div>
          <draggable
            v-model="item.menuPicDtos"
            @start="drag = true"
            :disabled="langCode !== langDic[0].value"
            @end="onDragEnd"
            item-key="index"
          >
            <template #item="{ element, index }">
              <div
                style="width: 100%;background: #DCDCDC;padding: 10px;position: relative;margin-top: 10px;"
              >
                <div
                  style="position: absolute;right: 10px;top: 10px"
                  @click="deletePic(item, index, langDic)"
                  v-if="langCode === langDic[0].value"
                >
                  <CloseOutlined />
                </div>
                <img
                  :src="element.picUrl"
                  v-if="element.picUrl"
                  alt=""
                  :style="{
                    width: '295px',
                    height: menu.bannerType - 0 === 1 ? '80px' : '145px'
                  }"
                />
                <a-upload
                  list-type="picture"
                  :beforeUpload="
                    e =>
                      beforeUpload(
                        e,
                        item,
                        langCode !== langDic[0].value,
                        langDic,
                        menu.bannerType,
                        element
                      )
                  "
                  :accept="
                    'image/png,image/jpeg,image/webp,image/gif,image/svg+xml,.png,.jpg,.jpeg,.gif,.webp,.bmp,.svg'
                  "
                  :showUploadList="false"
                >
                  <a-button class="mt10">
                    {{ element.picUrl ? '更换图片' : '上传图片' }}
                  </a-button>
                </a-upload>
                <MaterialSelectionListModal
                  style="margin-left:10px;display: inline-flex;"
                  @submit="
                    val =>
                      handleUpdateResourceMateral(
                        val,
                        item,
                        index,
                        langCode !== langDic[0].value,
                        langDic
                      )
                  "
                  :validateImageOrVideoArea="[
                    menu.bannerType - 0 === 1 ? `295*80` : `295*148`
                  ]"
                  :title="
                    menu.bannerType - 0 === 1
                      ? '素材选择 (295*80)'
                      : '素材选择 (295*148)'
                  "
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 5,
                    png: 5,
                    gif: 10,
                    jpeg: 5,
                    'image/png': 5,
                    'image/gif': 10,
                    'image/jpeg': 5,
                    'image/jpg': 5
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(postParams.siteId)"
                  :subTerminalId="getSubTerminalId()"
                >
                  <template #trigger>
                    <a-button class="mt10" type="primary">
                      {{
                        menu.bannerType - 0 === 1
                          ? '素材选择 (295*80)'
                          : '素材选择 (295*148)'
                      }}
                    </a-button>
                  </template>
                </MaterialSelectionListModal>
                <div class="mb4">链接：</div>
                <div class="mb10">
                  <a-radio-group
                    :disabled="langCode !== langDic[0].value"
                    v-model:value="element.urlType"
                    @change="
                      () => {
                        element.colId = null
                        element.menuUrl = null
                        element.addonBefore = null
                      }
                    "
                    name="radioGroup"
                  >
                    <a-radio :value="0">Collection链接</a-radio>
                    <a-radio :value="1">普通链接</a-radio>
                  </a-radio-group>
                </div>
                <div class="mb10">
                  <!-- {{ element }} -->
                  <a-input-group compact>
                    <a-input
                      v-if="
                        element.urlType - 0 === 0 &&
                          langCode === langDic[0].value
                      "
                      v-model:value="element.menuUrl"
                      @change="e => chnageMenuUrl(index, langDic)"
                    >
                      <template #addonBefore>
                        <a-tooltip>
                          <template #title> {{ element.addonBefore }}</template>
                          <div
                            class="addonBefore"
                            @click="
                              () =>
                                addonBeforeChange(
                                  true,
                                  undefined,
                                  element,
                                  index
                                )
                            "
                          >
                            {{ element.addonBefore }}
                          </div>
                        </a-tooltip>
                      </template>
                    </a-input>
                    <a-input
                      v-if="langCode !== langDic[0].value"
                      :value="
                        element?.menuUrl?.includes?.(element.addonBefore)
                          ? element.menuUrl
                          : `${element.addonBefore ? element.addonBefore : ''}${
                              element.menuUrl
                            }`
                      "
                      :disabled="true"
                      :style="`width: 100%;`"
                      placeholder="请输入"
                      auto-size
                    />
                    <a-textarea
                      v-if="
                        element.urlType - 0 === 1 &&
                          langCode === langDic[0].value
                      "
                      v-model:value="element.menuUrl"
                      @change="e => chnageMenuUrl(index)"
                      :style="`width: 100%;`"
                      placeholder="请输入"
                      auto-size
                    />
                  </a-input-group>
                </div>
                <p style="color: gray" v-if="element.urlType === 0">
                  输入框内请以"?"开头
                </p>
                <div
                  v-if="![null, ''].includes(element.colId) && element.colId"
                  style="color: #999999;"
                >
                  请点击后选择 当前Collection ID：{{ element.colId }}
                </div>
                <!-- <a-input
                  style="margin-top: 10px;"
                  v-model:value="element.menuUrl"
                  placeholder="请输入链接"
                  :disabled="langCode !== langDic[0].value"
                ></a-input> -->
              </div>
            </template>
          </draggable>
          <!-- <div v-for="(pic, index) in item.menuPics" :key="index">
            <div
              style="width: 100%;background: lightgrey;padding: 10px;position: relative;margin-top: 10px;"
            >
              <div
                style="position: absolute;right: 10px;top: 10px"
                @click="deletePic(item, index)"
              >
                关闭
              </div>
              <img
                :src="pic.picUrl"
                alt=""
                style="width: 100px; height: 100px;"
              />
              <a-input
                style="margin-top: 10px;"
                v-model:value="pic.menuUrl"
                placeholder="请输入链接"
              ></a-input>
            </div>
          </div> -->
        </div>
        <div v-else>
          <template
            v-if="
              !(
                menuType === 1 &&
                postParams.navType === 'header' &&
                postParams.subChannel === 1
              )
            "
          >
            <div><span class="red">*</span>名称：</div>
            <div class="mb10">
              <a-input
                v-model:value="item.menuName"
                placeholder="请输入名称"
                @change="
                  () =>
                    inputLengthCut(
                      {
                        val: item.menuName,
                        type: 2,
                        menuModule: 2
                      },
                      item
                    )
                "
              />
            </div>
          </template>
          <div
            v-if="
              postParams.navType === 'header' &&
                (postParams.subChannel === 2 || postParams.subChannel === -1) &&
                [0, 1].includes(postParams.navStyle)
            "
          >
            <span class="red">*</span>名称是否对客户显示：
            <a-popover
              overlay-class-name="popover-wrapper"
              :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode
                }
              "
            >
              <template #content>
                <p class="popover-text">
                  选择“是”表示组件名称需要显示在页面上，选择“否”表示组
                  件名称不需要显示在页面上
                </p>
              </template>
              <question-circle-outlined />
            </a-popover>
            <div class="mb10">
              <a-radio-group v-model:value="menu.showName" name="radioGroup">
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </div>
          </div>
          <div>色值：</div>
          <div class="mb10">
            <a-radio-group v-model:value="menu.menuColorType" name="radioGroup">
              <a-radio :value="1">单色</a-radio>
              <a-radio :value="2">多色</a-radio>
            </a-radio-group>
          </div>
          <div class="mb10" v-if="menu.menuColorType == 1">
            <colorPicker
              :disabled="langCode !== langDic[0].value"
              format="hex6"
              v-model:pureColor="menu.menuColor"
            ></colorPicker>
            <a-input
              v-model:value="menu.menuColor"
              class="w100"
              :disabled="true"
              placeholder="请输入色值"
            />
          </div>
          <div class="mb10" v-if="menu.menuColorType == 2">
            <colorPicker
              :disabled="langCode !== langDic[0].value"
              format="hex6"
              v-model:pureColor="menu.fromColor"
            ></colorPicker>
            <a-input
              v-model:value="menu.fromColor"
              class="w100 mr20px"
              :disabled="true"
              placeholder="请输入色值"
            />
            <colorPicker
              :disabled="langCode !== langDic[0].value"
              format="hex6"
              v-model:pureColor="menu.toColor"
            ></colorPicker>
            <a-input
              v-model:value="menu.toColor"
              class="w100"
              :disabled="true"
              placeholder="请输入色值"
            />
          </div>
          <!-- PC端 二级菜单（非广告）图片配置：非必填，素材选择，多语言，尺寸225*340（仅在图片导航样式下显示） -->
          <div
            v-if="
              menuType === 2 &&
                postParams.navType === 'header' &&
                postParams.subChannel === 1 &&
                menu.menuCategory === 1 &&
                menuList[checkIndex]?.layout - 0 !== 0 &&
                menu.menuType - 0 === 101
            "
            class="mb10"
          >
            <div>
              {{
                menuList[checkIndex]?.layout - 0 === 3 ||
                menuList[checkIndex]?.layout - 0 === 4
                  ? '图片（192*320，可选）：'
                  : '图片（225*340，可选）：'
              }}
            </div>
            <div style="display:flex;align-items:center;">
              <div class="img-wrapper-4" v-if="item.menuPic">
                <img
                  :src="item.menuPic"
                  style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                />
                <div class="hover-actions">
                  <EyeOutlined
                    class="action-icon"
                    @click="previewImg(item.menuPic)"
                  />
                  <DeleteOutlined
                    class="action-icon"
                    @click="
                      () => {
                        item.menuPic = null
                        Array.isArray(item.langs) &&
                          item.langs.forEach(l => {
                            l.menuPic = null
                            if (
                              Object.prototype.hasOwnProperty.call(
                                l,
                                'externalMaterialId'
                              )
                            )
                              delete l.externalMaterialId
                            if (
                              Object.prototype.hasOwnProperty.call(
                                l,
                                'externalMaterialSource'
                              )
                            )
                              delete l.externalMaterialSource
                          })
                      }
                    "
                  />
                </div>
              </div>
              <div
                v-else
                style="position: relative; width: 120px; height: 120px;"
              >
                <MaterialSelectionListModal
                  style="position: absolute; width: 100%; height: 100%; opacity: 0; left: 0; top: 0; z-index: 2;"
                  @submit="val => handleSubmit(val, item, -1)"
                  :validateImageOrVideoArea="[
                    menuList[checkIndex]?.layout - 0 === 3 ||
                    menuList[checkIndex]?.layout - 0 === 4
                      ? '192*320'
                      : '225*340'
                  ]"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    png: 5,
                    jpg: 5,
                    jpeg: 5,
                    gif: 10,
                    avif: 5,
                    'image/png': 5,
                    'image/gif': 10,
                    'image/jpeg': 5,
                    'image/jpg': 5,
                    'image/avif': 5
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(postParams.siteId)"
                  :subTerminalId="getSubTerminalId()"
                />
                <div
                  style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 4px; color: #999;"
                >
                  <div style="text-align: center;">
                    <div style="font-size: 20px;">+</div>
                    <div style="font-size: 12px;">上传图片</div>
                  </div>
                </div>
              </div>
              <MaterialSelectionListModal
                style="margin-left: 10px;"
                @submit="val => handleSubmit(val, item, -1)"
                :validateImageOrVideoArea="[
                  menuList[checkIndex]?.layout - 0 === 3 ||
                  menuList[checkIndex]?.layout - 0 === 4
                    ? '192*320'
                    : '225*340'
                ]"
                :validateImageOrVideoFormatAndSizeByMB="{
                  png: 5,
                  jpg: 5,
                  jpeg: 5,
                  gif: 10,
                  avif: 5,
                  'image/png': 5,
                  'image/gif': 10,
                  'image/jpeg': 5,
                  'image/jpg': 5,
                  'image/avif': 5
                }"
                :fileterResourceType="1"
                :siteId="Number(postParams.siteId)"
                :subTerminalId="getSubTerminalId()"
              >
                <template #trigger>
                  <a-button type="primary">素材选择</a-button>
                </template>
              </MaterialSelectionListModal>
            </div>
          </div>

          <!-- M端 二级菜单（非广告，非政策）图片配置：非必填，素材选择，多语言，高度28px -->
          <div
            v-if="
              menuType === 2 &&
                postParams.navType === 'header' &&
                postParams.subChannel === 2 &&
                menu.menuCategory === 1 &&
                menu.menuModule !== 2
            "
            class="mb10"
          >
            <div>图片（高度28px，可选）：</div>
            <div style="display:flex;align-items:center;">
              <div class="img-wrapper-4" v-if="item.menuPic">
                <img
                  :src="item.menuPic"
                  style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                />
                <div class="hover-actions">
                  <EyeOutlined
                    class="action-icon"
                    @click="previewImg(item.menuPic)"
                  />
                  <DeleteOutlined
                    class="action-icon"
                    @click="
                      () => {
                        item.menuPic = null
                        Array.isArray(item.langs) &&
                          item.langs.forEach(l => {
                            l.menuPic = null
                            if (
                              Object.prototype.hasOwnProperty.call(
                                l,
                                'externalMaterialId'
                              )
                            )
                              delete l.externalMaterialId
                            if (
                              Object.prototype.hasOwnProperty.call(
                                l,
                                'externalMaterialSource'
                              )
                            )
                              delete l.externalMaterialSource
                          })
                      }
                    "
                  />
                  <div class="edit-wrapper">
                    <EditOutlined class="action-icon" />
                    <div class="hidden-modal-trigger">
                      <MaterialSelectionListModal
                        :data-menuType="102"
                        @submit="val => handleSubmitMSecondHeight(val, item)"
                        :validateImageOrVideoArea="['*28']"
                        :validateImageOrVideoFormatAndSizeByMB="{
                          png: 5,
                          jpg: 5,
                          jpeg: 5,
                          gif: 10,
                          avif: 5,
                          'image/png': 5,
                          'image/gif': 10,
                          'image/jpeg': 5,
                          'image/jpg': 5,
                          'image/avif': 5
                        }"
                        :fileterResourceType="1"
                        :siteId="Number(postParams.siteId)"
                        :subTerminalId="getSubTerminalId()"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                style="position: relative; width: 120px; height: 120px;"
              >
                <div
                  style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; border-radius: 4px; color: #999;"
                >
                  <div style="text-align: center;">
                    <div style="font-size: 20px;">+</div>
                    <div style="font-size: 12px;">上传图片</div>
                  </div>
                </div>
              </div>
              <MaterialSelectionListModal
                style="margin-left: 10px;"
                :data-menuType="102"
                @submit="val => handleSubmitMSecondHeight(val, item)"
                :validateImageOrVideoArea="['*28']"
                :title="'素材选择 (高度28px)'"
                :validateImageOrVideoFormatAndSizeByMB="{
                  png: 5,
                  jpg: 5,
                  jpeg: 5,
                  gif: 10,
                  avif: 5,
                  'image/png': 5,
                  'image/gif': 10,
                  'image/jpeg': 5,
                  'image/jpg': 5,
                  'image/avif': 5
                }"
                :fileterResourceType="1"
                :siteId="Number(postParams.siteId)"
                :subTerminalId="getSubTerminalId()"
              >
                <template #trigger>
                  <a-button type="primary">素材选择</a-button>
                </template>
              </MaterialSelectionListModal>
            </div>
          </div>
          <div
            class="mb10"
            v-if="
              menuType === 1 &&
                postParams.navType === 'header' &&
                postParams.subChannel === 1
            "
          >
            <div><span class="red">*</span>名称：</div>
            <div class="mb10">
              <a-input
                v-model:value="item.menuName"
                placeholder="请输入名称"
                @change="
                  () =>
                    inputLengthCut(
                      {
                        val: item.menuName,
                        type: 2,
                        menuModule: 2
                      },
                      item
                    )
                "
              />
            </div>
            <div>图片（高度28，支持1/1.5/2/2.5/3倍图，宽度自适应）：</div>
            <div style="display:flex;align-items:center;">
              <div class="img-wrapper-4" v-if="item.menuPic">
                <img
                  :src="item.menuPic"
                  style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                />
                <div class="hover-actions">
                  <EyeOutlined
                    class="action-icon"
                    @click="previewImg(item.menuPic)"
                  />
                  <DeleteOutlined
                    class="action-icon"
                    @click="
                      () => {
                        item.menuPic = null
                        Array.isArray(item.langs) &&
                          item.langs.forEach(l => {
                            l.menuPic = null
                            if (
                              Object.prototype.hasOwnProperty.call(
                                l,
                                'externalMaterialId'
                              )
                            )
                              delete l.externalMaterialId
                            if (
                              Object.prototype.hasOwnProperty.call(
                                l,
                                'externalMaterialSource'
                              )
                            )
                              delete l.externalMaterialSource
                          })
                      }
                    "
                  />
                  <div class="edit-wrapper">
                    <EditOutlined class="action-icon" />
                    <div class="hidden-modal-trigger">
                      <MaterialSelectionListModal
                        @submit="val => handleSubmitHeaderFirstLevel(val, item)"
                        :fileterResourceType="1"
                        :siteId="Number(postParams.siteId)"
                        :subTerminalId="getSubTerminalId()"
                        :validateImageOrVideoArea="['*28']"
                        :validateImageOrVideoFormatAndSizeByMB="{
                          png: 5,
                          jpg: 5,
                          jpeg: 5,
                          gif: 10,
                          avif: 5,
                          'image/png': 5,
                          'image/gif': 10,
                          'image/jpeg': 5,
                          'image/jpg': 5,
                          'image/avif': 5
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                style="position: relative; width: 120px; height: 120px;"
              >
                <MaterialSelectionListModal
                  style="position: absolute; width: 100%; height: 100%; opacity: 0; left: 0; top: 0; z-index: 2;"
                  @submit="val => handleSubmitHeaderFirstLevel(val, item)"
                  :fileterResourceType="1"
                  :siteId="Number(postParams.siteId)"
                  :subTerminalId="getSubTerminalId()"
                  :validateImageOrVideoArea="['*28']"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    png: 5,
                    jpg: 5,
                    jpeg: 5,
                    gif: 10,
                    avif: 5,
                    'image/png': 5,
                    'image/gif': 10,
                    'image/jpeg': 5,
                    'image/jpg': 5,
                    'image/avif': 5
                  }"
                />
                <div
                  style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 4px; color: #999;"
                >
                  <div style="text-align: center;">
                    <div style="font-size: 20px;">+</div>
                    <div style="font-size: 12px;">上传图片</div>
                  </div>
                </div>
              </div>
              <MaterialSelectionListModal
                style="margin-left: 10px;"
                @submit="val => handleSubmitHeaderFirstLevel(val, item)"
                :fileterResourceType="1"
                :siteId="Number(postParams.siteId)"
                :subTerminalId="getSubTerminalId()"
                :validateImageOrVideoArea="['*28']"
                :validateImageOrVideoFormatAndSizeByMB="{
                  png: 5,
                  jpg: 5,
                  jpeg: 5,
                  gif: 10,
                  avif: 5,
                  'image/png': 5,
                  'image/gif': 10,
                  'image/jpeg': 5,
                  'image/jpg': 5,
                  'image/avif': 5
                }"
              >
                <template #trigger>
                  <a-button type="primary">素材选择</a-button>
                </template>
              </MaterialSelectionListModal>
            </div>
          </div>
          <div
            v-if="
              menuType === 2 &&
                menu.canImg &&
                !(
                  postParams.navType === 'header' &&
                  postParams.subChannel === 1 &&
                  menu.menuCategory === 1
                )
            "
          >
            <div><span class="red">*</span>图片：</div>
            <div class="mb10">
              <div style="display: flex;align-items: center;">
                <div
                  v-if="!['', null].includes(item.menuPic)"
                  style="width: 120px;height: 120px; position: relative;"
                  class="img-wrapper-4"
                >
                  <div class="drawUploadImg">
                    <img
                      :src="item.menuPic"
                      style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                    />

                    <div class="hover-actions">
                      <EyeOutlined
                        class="action-icon"
                        @click="previewImg(item.menuPic)"
                      />
                      <DeleteOutlined
                        style="color: white;"
                        @click="
                          () => {
                            item.menuPic = null
                            langDic.forEach(dic => (dic.menuPic = null))
                          }
                        "
                      />
                    </div>
                  </div>
                </div>
                <template v-if="postParams.subChannel === 1 && item.menuPic">
                  <MaterialSelectionListModal
                    style="margin-left: 10px;"
                    @submit="val => handleSubmit(val, item, -1)"
                    :validateImageOrVideoArea="[
                      menuList[checkIndex]?.layout - 0 === 3 ||
                      menuList[checkIndex]?.layout - 0 === 4
                        ? '192*320'
                        : '225*340'
                    ]"
                    :validateImageOrVideoFormatAndSizeByMB="{
                      png: 5,
                      jpg: 5,
                      jpeg: 5,
                      gif: 10,
                      avif: 5,
                      'image/png': 5,
                      'image/gif': 10,
                      'image/jpeg': 5,
                      'image/jpg': 5,
                      'image/avif': 5
                    }"
                    :fileterResourceType="1"
                    :siteId="Number(postParams.siteId)"
                    :subTerminalId="getSubTerminalId()"
                  >
                    <template #trigger>
                      <a-button type="primary">素材选择</a-button>
                    </template>
                  </MaterialSelectionListModal>
                </template>
                <template v-if="postParams.subChannel === 2 && item.menuPic">
                  <MaterialSelectionListModal
                    style="margin-left: 10px;"
                    @submit="val => handleSubmit(val, item, -1)"
                    :validateImageOrVideoArea="['44*44']"
                    :validateImageOrVideoFormatAndSizeByMB="{
                      png: 5,
                      jpg: 5,
                      jpeg: 5,
                      gif: 10,
                      avif: 5,
                      'image/png': 5,
                      'image/gif': 10,
                      'image/jpeg': 5,
                      'image/jpg': 5,
                      'image/avif': 5
                    }"
                    :fileterResourceType="1"
                    :siteId="Number(postParams.siteId)"
                    :subTerminalId="getSubTerminalId()"
                  >
                    <template #trigger>
                      <a-button type="primary">素材选择</a-button>
                    </template>
                  </MaterialSelectionListModal>
                </template>
                <!-- PC端 -->
                <template v-if="postParams.subChannel === 1 && !item.menuPic">
                  <div style="position: relative; width: 120px; height: 120px;">
                    <MaterialSelectionListModal
                      style="position: absolute; width: 100%; height: 100%; opacity: 0; left: 0; top: 0; z-index: 2;"
                      @submit="val => handleSubmit(val, item, -1)"
                      :validateImageOrVideoArea="[
                        menuList[checkIndex]?.layout - 0 === 3 ||
                        menuList[checkIndex]?.layout - 0 === 4
                          ? '192*320'
                          : '225*340'
                      ]"
                      :validateImageOrVideoFormatAndSizeByMB="{
                        png: 5,
                        jpg: 5,
                        jpeg: 5,
                        gif: 10,
                        avif: 5,
                        'image/png': 5,
                        'image/gif': 10,
                        'image/jpeg': 5,
                        'image/jpg': 5,
                        'image/avif': 5
                      }"
                      :fileterResourceType="1"
                      :siteId="Number(postParams.siteId)"
                      :subTerminalId="getSubTerminalId()"
                    />
                    <div
                      style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 4px; color: #999;"
                    >
                      <div style="text-align: center;">
                        <div style="font-size: 20px;">+</div>
                        <div style="font-size: 12px;">上传图片</div>
                      </div>
                    </div>
                  </div>
                  <MaterialSelectionListModal
                    style="margin-left: 10px;"
                    @submit="val => handleSubmit(val, item, -1)"
                    :validateImageOrVideoArea="[
                      menuList[checkIndex]?.layout - 0 === 3 ||
                      menuList[checkIndex]?.layout - 0 === 4
                        ? '192*320'
                        : '225*340'
                    ]"
                    :validateImageOrVideoFormatAndSizeByMB="{
                      png: 5,
                      jpg: 5,
                      jpeg: 5,
                      gif: 10,
                      avif: 5,
                      'image/png': 5,
                      'image/gif': 10,
                      'image/jpeg': 5,
                      'image/jpg': 5,
                      'image/avif': 5
                    }"
                    :fileterResourceType="1"
                    :siteId="Number(postParams.siteId)"
                    :subTerminalId="getSubTerminalId()"
                  >
                    <template #trigger>
                      <a-button type="primary">素材选择</a-button>
                    </template>
                  </MaterialSelectionListModal>
                </template>
                <!-- M端 -->
                <template v-if="postParams.subChannel === 2 && !item.menuPic">
                  <div style="position: relative; width: 120px; height: 120px;">
                    <MaterialSelectionListModal
                      style="position: absolute; width: 100%; height: 100%; opacity: 0; left: 0; top: 0; z-index: 2;"
                      @submit="val => handleSubmit(val, item, -1)"
                      :validateImageOrVideoArea="['44*44']"
                      :validateImageOrVideoFormatAndSizeByMB="{
                        png: 5,
                        jpg: 5,
                        jpeg: 5,
                        gif: 10,
                        avif: 5,
                        'image/png': 5,
                        'image/gif': 10,
                        'image/jpeg': 5,
                        'image/jpg': 5,
                        'image/avif': 5
                      }"
                      :fileterResourceType="1"
                      :siteId="Number(postParams.siteId)"
                      :subTerminalId="getSubTerminalId()"
                    />
                    <div
                      style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 4px; color: #999;"
                    >
                      <div style="text-align: center;">
                        <div style="font-size: 20px;">+</div>
                        <div style="font-size: 12px;">上传图片</div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- PC端 三级菜单 图片配置：非必填，素材选择，多语言，尺寸225*136 -->
          <div
            v-if="
              menuType === 3 &&
                postParams.navType === 'header' &&
                postParams.subChannel === 1
            "
            class="mb10"
          >
            <div>图片（225*136，可选）：</div>
            <div style="display:flex;align-items:center;">
              <div class="img-wrapper-4" v-if="item.menuPic">
                <img
                  :src="item.menuPic"
                  style="height: 90px; width: 150px; object-fit: cover; border-radius: 4px; background-color: #f5f5f5;"
                />
                <div class="hover-actions">
                  <EyeOutlined
                    class="action-icon"
                    @click="previewImg(item.menuPic)"
                  />
                  <DeleteOutlined
                    class="action-icon"
                    @click="
                      () => {
                        item.menuPic = null
                        langDic.forEach(dic => (dic.menuPic = null))
                      }
                    "
                  />
                </div>
              </div>
              <MaterialSelectionListModal
                style="margin-top:10px; display: inline-flex"
                @submit="val => handleSubmitThirdPc(val, item)"
                :validateImageOrVideoArea="['225*136']"
                :validateImageOrVideoFormatAndSizeByMB="{
                  png: 5,
                  jpg: 5,
                  jpeg: 5,
                  gif: 10,
                  avif: 5,
                  'image/png': 5,
                  'image/gif': 10,
                  'image/jpeg': 5,
                  'image/jpg': 5,
                  'image/avif': 5
                }"
                :fileterResourceType="1"
                :siteId="Number(postParams.siteId)"
                :subTerminalId="getSubTerminalId()"
              />
            </div>
          </div>
          <div
            v-if="
              menuType === 2 &&
                menu.canImg &&
                !(
                  postParams.navType === 'header' &&
                  postParams.subChannel === 1 &&
                  menu.menuCategory === 1
                )
            "
          >
            <div v-if="uploadErr" class="red lh30 h30 mb10">
              {{ uploadErr }}
            </div>
            <div v-else class="lh20 h40 mb10" style="color: #cccccc;">
              支持png、jpg、gif等格式上传；图片的宽高比为{{
                menuList[checkIndex]?.layout - 0 === 3 ||
                menuList[checkIndex]?.layout - 0 === 4
                  ? '192*320'
                  : '225*340'
              }}；且大小在5M以内；
            </div>
          </div>
          <template v-if="postParams.subChannel !== -1">
            <div class="mb4">链接：</div>
            <div class="mb10">
              <a-radio-group
                :disabled="langCode !== langDic[0].value"
                v-model:value="menu.urlType"
                @change="
                  () => {
                    menu.colId = null
                    menu.menuUrl = null
                    menu.addonBefore = null
                  }
                "
                name="radioGroup"
              >
                <a-radio :value="0">Collection链接</a-radio>
                <a-radio :value="1">普通链接</a-radio>
              </a-radio-group>
            </div>
            <div class="mb10">
              <a-input-group compact>
                <a-input
                  v-if="menu.urlType - 0 === 0 && langCode === langDic[0].value"
                  v-model:value="menu.menuUrl"
                >
                  <template #addonBefore>
                    <a-tooltip>
                      <template #title> {{ menu.addonBefore }}</template>
                      <div
                        class="addonBefore"
                        @click="() => addonBeforeChange(true)"
                      >
                        {{ menu.addonBefore }}
                      </div>
                    </a-tooltip>
                  </template>
                </a-input>
                <a-input
                  v-if="langCode !== langDic[0].value"
                  :value="
                    menu?.menuUrl?.includes?.(menu.addonBefore)
                      ? menu.menuUrl
                      : `${menu.addonBefore ? menu.addonBefore : ''}${
                          menu.menuUrl
                        }`
                  "
                  :disabled="true"
                  :style="`width: 100%;`"
                  placeholder="请输入"
                />
                <a-textarea
                  v-if="menu.urlType - 0 === 1 && langCode === langDic[0].value"
                  v-model:value="menu.menuUrl"
                  :style="`width: 100%;`"
                  placeholder="请输入"
                />
              </a-input-group>
            </div>
            <p style="color: gray" v-if="menu.urlType === 0">
              输入框内请以"?"开头
            </p>
            <div
              v-if="![null, ''].includes(menu.colId) && menu.colId"
              style="color: #999999;"
            >
              请点击后选择 当前Collection ID：{{ menu.colId }}
            </div>
          </template>
          <template v-else>
            <div style="display: flex;align-items: center;margin-bottom: 12px;">
              <div class="name">自研collection id：</div>
              <div class="mr10" v-if="menu.colId">
                {{ menu.colId }}
              </div>
              <a-button @click="addonBeforeChange(true)">{{
                !menu.colId ? '选择' : '修改'
              }}</a-button>
            </div>
            <div style="display: flex;align-items: center;margin-bottom: 12px;">
              <div class="name">链接：</div>
              <div class="wd400">
                <a-input
                  placeholder="请输入链接"
                  v-model:value="menu.menuUrl"
                />
              </div>
            </div>
          </template>

          <div
            class="mb10"
            v-if="
              menuType === 1 &&
                postParams.navType === 'header' &&
                postParams.subChannel === 1
            "
          >
            <div class="mb4"><span class="red">*</span>子菜单样式布局：</div>
            <div class="mb10">
              <a-radio-group
                v-model:value="menu.layout"
                name="radioGroup"
                @change="() => changeLayout()"
                :disabled="langCode !== langDic[0].value"
              >
                <!-- :disabled="menu.id" -->
                <a-radio :value="0">纯文本</a-radio>
                <a-radio :value="1">单图</a-radio>
                <a-radio :value="2">双图</a-radio>
              </a-radio-group>
            </div>
            <div v-if="menu.layout - 0 === 0">
              <img :src="pic01" style="width: 100%;" />
            </div>
            <div v-if="menu.layout - 0 === 1">
              <img :src="pic02" style="width: 100%;" />
            </div>
            <div v-if="menu.layout - 0 === 2">
              <img :src="pic03" style="width: 100%;" />
            </div>
          </div>
          <div
            class="mt10"
            v-if="
              (drawVisible &&
                postParams.navType === 'header' &&
                ((postParams.navStyle - 0 === 1 &&
                  (menuType === 2 || menuType === 4)) ||
                  (postParams.navStyle - 0 === 0 && menuType === 4)) &&
                (postParams.subChannel === 2 ||
                  postParams.subChannel === -1)) ||
                menu.menuModule === 2
            "
          >
            <template v-if="drawVisible">
              <!-- app -->
              <template v-if="postParams.subChannel === -1">
                <MaterialSelectionListModal
                  :data-menumodle="menu.menuModule"
                  :validateImageOrVideoArea="[
                    menuType === 2 ? `255*118` : `74*111`
                  ]"
                  :data-menuType="menuType"
                  style="margin-top:10px; display: flex;"
                  @submit="val => handleSubmit(val, item, -1)"
                  :validateImageOrVideoFormatAndSizeByMB="{
                    jpg: 5,
                    png: 5,
                    gif: 10,
                    jpeg: 5,
                    avif: 5,
                    'image/png': 5,
                    'image/gif': 10,
                    'image/jpeg': 5,
                    'image/jpg': 5,
                    'image/avif': 5
                  }"
                  :fileterResourceType="1"
                  :siteId="Number(postParams.siteId)"
                  :subTerminalId="3"
                />
              </template>
              <!-- m端 -->
              <template v-if="postParams.subChannel === 2">
                <!-- m端菜单 -->
                <template v-if="menu.menuModule === 1">
                  <!-- m端二级菜单 -->
                  <template v-if="menuType == 2 && menu.menuCategory !== 2">
                    <MaterialSelectionListModal
                      :data-menumodle="menu.menuModule"
                      :data-menuType="menuType"
                      :validateImageOrVideoArea="[`44*44`]"
                      style="margin-top:10px; display: flex;justify-content: center;margin-left: 15px;"
                      @submit="val => handleSubmit(val, item, -1)"
                      :validateImageOrVideoFormatAndSizeByMB="{
                        jpg: 0.02,
                        png: 0.02,
                        gif: 10,
                        jpeg: 0.02,
                        avif: 0.02,
                        'image/png': 0.02,
                        'image/gif': 10,
                        'image/jpeg': 0.02,
                        'image/jpg': 0.02,
                        'image/avif': 0.02
                      }"
                      :fileterResourceType="1"
                      :siteId="Number(postParams.siteId)"
                      :subTerminalId="getSubTerminalId()"
                    />
                  </template>
                  <template v-if="menuType == 4">
                    <!-- M端 三级菜单为banner多图时，四级菜单支持上传图片 -->
                    <div
                      v-if="
                        fourParent().imgStyle - 0 === 3 &&
                          postParams.navStyle - 0 === 0
                      "
                    >
                      <div
                        class="selectionRow"
                        style="position: relative; border: none; padding: 0;"
                      >
                        <span class="red" style="margin-right: 8px;">*</span>
                        <div class="img-wrapper-4" v-if="item.menuPic">
                          <img
                            :src="item.menuPic"
                            style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                          />
                          <div class="hover-actions">
                            <EyeOutlined
                              class="action-icon"
                              @click="previewImg(item.menuPic)"
                            />
                            <DeleteOutlined
                              class="action-icon"
                              @click="
                                () => {
                                  item.menuPic = null
                                  Array.isArray(item.langs) &&
                                    item.langs.forEach(l => {
                                      l.menuPic = null
                                      if (
                                        Object.prototype.hasOwnProperty.call(
                                          l,
                                          'externalMaterialId'
                                        )
                                      )
                                        delete l.externalMaterialId
                                      if (
                                        Object.prototype.hasOwnProperty.call(
                                          l,
                                          'externalMaterialSource'
                                        )
                                      )
                                        delete l.externalMaterialSource
                                    })
                                }
                              "
                            />
                            <div class="edit-wrapper">
                              <EditOutlined class="action-icon" />
                              <div class="hidden-modal-trigger">
                                <MaterialSelectionListModal
                                  :data-menumodle="menu.menuModule"
                                  :data-menuType="menuType"
                                  :validateImageOrVideoArea="['225*340']"
                                  :validateImageOrVideoFormatAndSizeByMB="{
                                    jpg: 5,
                                    png: 5,
                                    gif: 10,
                                    jpeg: 5,
                                    avif: 5,
                                    'image/png': 5,
                                    'image/gif': 10,
                                    'image/jpeg': 5,
                                    'image/jpg': 5,
                                    'image/avif': 5
                                  }"
                                  @submit="val => handleSubmit(val, item, -1)"
                                  :fileterResourceType="1"
                                  :siteId="Number(postParams.siteId)"
                                  :subTerminalId="getSubTerminalId()"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="!item.menuPic"
                          style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; border-radius: 4px; color: #999;"
                        >
                          <div style="text-align: center;">
                            <div style="font-size: 20px;">+</div>
                            <div style="font-size: 12px;">上传图片</div>
                          </div>
                        </div>
                        <MaterialSelectionListModal
                          style="margin-top: 10px; display: inline-flex; cursor: pointer;"
                          :data-menumodle="menu.menuModule"
                          :data-menuType="menuType"
                          :validateImageOrVideoArea="['225*340']"
                          :validateImageOrVideoFormatAndSizeByMB="{
                            jpg: 5,
                            png: 5,
                            gif: 10,
                            jpeg: 5,
                            avif: 5,
                            'image/png': 5,
                            'image/gif': 10,
                            'image/jpeg': 5,
                            'image/jpg': 5,
                            'image/avif': 5
                          }"
                          @submit="val => handleSubmit(val, item, -1)"
                          :fileterResourceType="1"
                          :siteId="Number(postParams.siteId)"
                          :subTerminalId="getSubTerminalId()"
                        >
                          <template #trigger>
                            <a-button type="primary">素材选择</a-button>
                          </template>
                        </MaterialSelectionListModal>
                      </div>
                      <div
                        style="color: #999; font-size: 12px; line-height: 1.5; margin-top: 4px;"
                      >
                        支持png、jpg、gif等格式上传；图片的尺寸为225*340，且大小在5M以内；
                      </div>
                    </div>
                    <div v-if="menuType == 4 && postParams.navStyle - 0 !== 0">
                      <div>
                        <div
                          class="selectionRow"
                          style="position: relative; border: none; padding: 0;"
                        >
                          <span class="red" style="margin-right: 8px;">*</span>
                          <div class="img-wrapper-4" v-if="item.menuPic">
                            <img
                              :src="item.menuPic"
                              style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                            />
                            <div class="hover-actions">
                              <EyeOutlined
                                class="action-icon"
                                @click="previewImg(item.menuPic)"
                              />
                              <DeleteOutlined
                                class="action-icon"
                                @click="
                                  () => {
                                    item.menuPic = null
                                    langDic.forEach(dic => (dic.menuPic = null))
                                  }
                                "
                              />
                              <div class="edit-wrapper">
                                <EditOutlined class="action-icon" />
                                <div class="hidden-modal-trigger">
                                  <MaterialSelectionListModal
                                    :data-menumodle="menu.menuModule"
                                    :data-menuType="menuType"
                                    :validateImageOrVideoArea="['225*340']"
                                    :validateImageOrVideoFormatAndSizeByMB="{
                                      jpg: 5,
                                      png: 5,
                                      gif: 10,
                                      jpeg: 5,
                                      avif: 5,
                                      'image/png': 5,
                                      'image/gif': 10,
                                      'image/jpeg': 5,
                                      'image/jpg': 5,
                                      'image/avif': 5
                                    }"
                                    @submit="val => handleSubmit(val, item, -1)"
                                    :fileterResourceType="1"
                                    :siteId="Number(postParams.siteId)"
                                    :subTerminalId="getSubTerminalId()"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="!item.menuPic"
                            style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; border-radius: 4px; color: #999;"
                          >
                            <div style="text-align: center;">
                              <div style="font-size: 20px;">+</div>
                              <div style="font-size: 12px;">上传图片</div>
                            </div>
                          </div>
                        </div>
                        <MaterialSelectionListModal
                          style="margin-top: 10px; display: inline-flex; cursor: pointer;"
                          :data-menumodle="menu.menuModule"
                          :data-menuType="menuType"
                          :validateImageOrVideoArea="['225*340']"
                          :validateImageOrVideoFormatAndSizeByMB="{
                            jpg: 5,
                            png: 5,
                            gif: 10,
                            jpeg: 5,
                            avif: 5,
                            'image/png': 5,
                            'image/gif': 10,
                            'image/jpeg': 5,
                            'image/jpg': 5,
                            'image/avif': 5
                          }"
                          @submit="val => handleSubmit(val, item, -1)"
                          :fileterResourceType="1"
                          :siteId="Number(postParams.siteId)"
                          :subTerminalId="getSubTerminalId()"
                        >
                          <template #trigger>
                            <a-button type="primary">素材选择</a-button>
                          </template>
                        </MaterialSelectionListModal>
                      </div>
                      <div
                        style="color: #999; font-size: 12px; line-height: 1.5; margin-top: 4px;"
                      >
                        支持png、jpg、gif等格式上传；图片的尺寸为225*340，且大小在5M以内；
                      </div>
                    </div>
                  </template>
                </template>
                <!-- m端政策菜单（保留48*48图片模块） -->
                <template v-if="menu.menuModule === 2">
                  <div style="display:flex;align-items:center;">
                    <div class="img-wrapper-4" v-if="item.menuPic">
                      <img
                        :src="item.menuPic"
                        style="width: 120px; height: 120px; object-fit: contain; border-radius: 4px; background-color: #f5f5f5;"
                      />
                      <div class="hover-actions">
                        <EyeOutlined
                          class="action-icon"
                          @click="previewImg(item.menuPic)"
                        />
                        <div class="edit-wrapper">
                          <EditOutlined class="action-icon" />
                          <div class="hidden-modal-trigger">
                            <MaterialSelectionListModal
                              :data-menumodle="menu.menuModule"
                              :data-menuType="menuType"
                              :validateImageOrVideoArea="['48*48']"
                              style="margin-top:10px; display: flex;"
                              @submit="val => handleSubmit(val, item, -1)"
                              :validateImageOrVideoFormatAndSizeByMB="{
                                jpg: 5,
                                png: 5,
                                gif: 10,
                                jpeg: 5,
                                avif: 5,
                                'image/png': 5,
                                'image/gif': 10,
                                'image/jpeg': 5,
                                'image/jpg': 5,
                                'image/avif': 5
                              }"
                              :fileterResourceType="1"
                              :siteId="Number(postParams.siteId)"
                              :subTerminalId="getSubTerminalId()"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; display: flex; justify-content: center; align-items: center; border-radius: 4px; color: #999;"
                    >
                      <div style="text-align: center;">
                        <div style="font-size: 20px;">+</div>
                        <div style="font-size: 12px;">上传图片</div>
                      </div>
                    </div>
                    <MaterialSelectionListModal
                      :data-menumodle="menu.menuModule"
                      :data-menuType="menuType"
                      :validateImageOrVideoArea="['48*48']"
                      style="margin-left:10px;"
                      @submit="val => handleSubmit(val, item, -1)"
                      :validateImageOrVideoFormatAndSizeByMB="{
                        jpg: 5,
                        png: 5,
                        gif: 10,
                        jpeg: 5,
                        avif: 5,
                        'image/png': 5,
                        'image/gif': 10,
                        'image/jpeg': 5,
                        'image/jpg': 5,
                        'image/avif': 5
                      }"
                      :fileterResourceType="1"
                      :siteId="Number(postParams.siteId)"
                      :subTerminalId="getSubTerminalId()"
                    >
                      <template #trigger>
                        <a-button type="primary">素材选择</a-button>
                      </template>
                    </MaterialSelectionListModal>
                  </div>
                  <div
                    style="color: #999; font-size: 12px; line-height: 1.5; margin-top: 4px;"
                  >
                    支持png格式上传；图片的尺寸为48*48，且大小在5M以内；
                  </div>
                </template>
              </template>
            </template>
          </div>
          <div
            class="mt10"
            v-if="
              (postParams.subChannel === 2 || postParams.subChannel === -1) &&
                menuType === 3 &&
                postParams.navStyle === 1
            "
          >
            <span class="red">*</span>图片样式：
            <a-radio-group v-model:value="menu.imgStyle" name="radioGroup">
              <a-radio :value="0">banner长图</a-radio>
              <a-radio :value="1">banner双图</a-radio>
              <a-radio :value="2">分类组件</a-radio>
              <a-radio :value="3">banner多图</a-radio>
            </a-radio-group>
          </div>
          <div
            class="mt10"
            v-if="
              postParams.subChannel === 2 &&
                menuType === 3 &&
                postParams.navStyle === 0
            "
          >
            子菜单样式：
            <a-radio-group v-model:value="menu.imgStyle" name="radioGroup">
              <a-radio :value="0">纯文本</a-radio>
              <a-radio :value="3">banner多图</a-radio>
            </a-radio-group>
          </div>
          <div class="mt20">
            <c-checkBox
              v-model:praceLock="menu.raceLock"
              v-if="menu.menuModule !== 2"
            />
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>

    <div
      class="pa l0 b0 pt10 pb10 tar"
      style="border-top: 1px solid #e8e8e8; width: calc(100%); background: #ffffff;"
    >
      <a-button type="default" class="mr10" @click="closeDraw">取消</a-button>
      <a-button
        type="primary"
        class="mr10"
        @click="
          () => {
            onSaveAdd(menuType)
          }
        "
        v-if="addOrEdit === 1"
        >确定</a-button
      >
      <a-button
        type="primary"
        class="mr10"
        @click="
          () => {
            onSaveEdit(menuType)
          }
        "
        v-if="addOrEdit === 2"
        >确定</a-button
      >
    </div>
  </a-drawer>

  <a-modal v-model:visible="visiblePic" title="查看大图" style="width: 800px;">
    <div class="showBigPic">
      <img :src="previewPicUrl || menu.menuPic" style="width: 100%;" />
    </div>
    <template #footer></template>
  </a-modal>
</template>
<script>
// import UploadImg from './UploadImg.vue'
import { ColorPicker } from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'
import { toRefs, inject, reactive } from 'vue'
import {
  EyeOutlined,
  QuestionCircleOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  UploadOutlined
} from '@ant-design/icons-vue'
import CCheckBox from './CCheckBox.vue'
import draggable from 'vuedraggable'
import { message } from 'ant-design-vue'
import MaterialSelectionListModal from '@/components/MaterialSelectionListModal/index.vue'

export default {
  components: {
    MaterialSelectionListModal,
    ColorPicker,
    EyeOutlined,
    QuestionCircleOutlined,
    CCheckBox,
    // UploadImg,
    draggable,
    CloseOutlined,
    EditOutlined,
    DeleteOutlined,
    UploadOutlined
  },
  setup() {
    const state = reactive({
      previewPicUrl: '',
      visiblePic: false,
      checked: false,
      menuImageType: ['300*120', '146*60', '60*60', '146*60'],
      menuImageSize: [
        {
          jpg: 0.1,
          png: 0.1,
          gif: 0.1,
          jpeg: 0.1
        },
        {
          jpg: 0.1,
          png: 0.1,
          gif: 0.1,
          jpeg: 0.1
        },
        {
          jpg: 0.02,
          png: 0.02,
          gif: 0.02,
          jpeg: 0.02
        },
        {
          jpg: 0.1,
          png: 0.1,
          gif: 0.1,
          jpeg: 0.1
        }
      ]
    })
    const initState = inject('initState')

    return {
      ...toRefs(state),
      ...toRefs(initState),
      getSubTerminalId: () => {
        const sub = initState.postParams.subChannel - 0
        return sub === -1 ? 3 : sub
      },
      fourParent: () => {
        return (
          initState.menuList[initState.checkIndex]?.menuList?.[
            initState.sonCheckIndex
          ]?.menuList?.[initState.gsCheckIndex] || { menuList: [], imgStyle: 0 }
        )
      },
      pic01:
        'https://cdn-image.kapeixi.cn/web/27a724f3-a2cb-4eb8-a0f3-726dfd876707/纯文本.png',
      pic02:
        'https://cdn-image.kapeixi.cn/web/82bde744-8d9f-40c9-be6b-84a9e2db4dd0/单图.png',
      pic03:
        'https://cdn-image.kapeixi.cn/web/7f77feeb-e20c-43c2-919c-6483c443ac37/双图.png',
      previewImg(url) {
        state.previewPicUrl = url
        state.visiblePic = true
      },
      handleSubmit(file, item, index = -1) {
        console.log(file, item, index)
        initState.updateMaterial(
          {
            uid: '1',
            name: file.url,
            status: 'done',
            response: '200',
            url: file.url,
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          },
          Object.assign(item, {
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          }),
          index
        )
      },
      handleSubmitMSecondHeight(file, item) {
        initState.updateMaterial(
          {
            uid: '1',
            name: file.url,
            status: 'done',
            response: '200',
            url: file.url,
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          },
          item,
          -1
        )
      },
      handleSubmitThirdPc(file, item) {
        item.menuPic = file.url
        initState.updateMaterial(
          {
            uid: '1',
            name: file.url,
            status: 'done',
            response: '200',
            url: file.url,
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          },
          Object.assign(item, {
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          }),
          -1
        )
      },
      handleSubmitHeaderFirstLevel(file, item) {
        item.menuPic = file.url
        initState.updateMaterial(
          {
            uid: '1',
            name: file.url,
            status: 'done',
            response: '200',
            url: file.url,
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          },
          Object.assign(item, {
            externalMaterialId: file.materialNo,
            externalMaterialSource: file.source
          }),
          -1
        )
      },
      handleUpdateResourceMateral: (info, item, index, langCode, langDic) => {
        if (item.menuPicDtos?.length >= 3 && index === -1) {
          message.error('最多上传3张图片')
          return
        }
        initState.updateResourceMateral(info, item, index, langCode, langDic)
      },
      onSaveAdd: type => {
        if (
          type === 1 &&
          initState.postParams.navType === 'header' &&
          initState.postParams.subChannel === 1 &&
          ([null, undefined, ''].includes(initState.menu.layout) ||
            initState.menu.layout === null)
        ) {
          message.error('请选择子菜单样式布局')
          return
        }
        if (
          type === 4 &&
          initState.postParams.subChannel === 2 &&
          initState.menu.menuModule === 1
        ) {
          const fourParent = initState.menuList[initState.checkIndex]
            ?.menuList?.[initState.sonCheckIndex]?.menuList?.[
            initState.gsCheckIndex
          ] || {
            menuList: [],
            imgStyle: 0
          }
          const isTextNav = initState.postParams.navStyle - 0 === 0
          const parentImgStyle = fourParent.imgStyle - 0

          if ((isTextNav && parentImgStyle === 3) || !isTextNav) {
            const langs = initState.langDic
            for (let i = 0; i < langs.length; i++) {
              if (!langs[i].menuPic) {
                message.error(`请上传${langs[i].label}图片`)
                return
              }
            }
          }
        }
        initState.addMenu(type)
      },
      onSaveEdit: type => {
        if (
          type === 1 &&
          initState.postParams.navType === 'header' &&
          initState.postParams.subChannel === 1 &&
          ([null, undefined, ''].includes(initState.menu.layout) ||
            initState.menu.layout === null)
        ) {
          message.error('请选择子菜单样式布局')
          return
        }
        if (
          type === 4 &&
          initState.postParams.subChannel === 2 &&
          initState.menu.menuModule === 1
        ) {
          const fourParent = initState.menuList[initState.checkIndex]
            ?.menuList?.[initState.sonCheckIndex]?.menuList?.[
            initState.gsCheckIndex
          ] || {
            menuList: [],
            imgStyle: 0
          }
          const isTextNav = initState.postParams.navStyle - 0 === 0
          const parentImgStyle = fourParent.imgStyle - 0

          if ((isTextNav && parentImgStyle === 3) || !isTextNav) {
            const langs = initState.langDic
            for (let i = 0; i < langs.length; i++) {
              if (!langs[i].menuPic) {
                message.error(`请上传${langs[i].label}图片`)
                return
              }
            }
          }
        }
        initState.editMenu(type)
      }
    }
  }
}
</script>
<style scoped>
.layoutPreviewSvg {
  width: 100%;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 10px;
}
.selectionRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  margin: 6px 0;
}
.actions {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.controlRow {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.drawUploadImg {
  position: absolute;
  left: 0;
  top: 0;
}

.drawUploadImg .hover {
  display: none;
  background: rgba(0, 0, 0, 0.3);
  width: 120px;
  height: 120px;
}

.drawUploadImg:hover .hover {
  display: block;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
}

.addonBefore {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
}

:deep(.ant-popover-inner) {
  background-color: rgba(0, 0, 0, 0.75);
}

:deep(.ant-popover-inner-content) {
  padding: 4px;
}
:deep(.ant-popover-arrow-content) {
  background-color: rgba(0, 0, 0, 0.75);
}
.popover-text {
  width: 300px;
  color: #ffffff;
  font-size: 12px;
}
.img-wrapper-4 {
  position: relative;
  display: inline-block;
  margin-right: 8px;
}
.img-wrapper-4:hover .hover-actions {
  display: flex;
}
.hover-actions {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
}
.action-icon {
  color: white;
  cursor: pointer;
  font-size: 16px;
}
.edit-wrapper {
  position: relative;
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.hidden-modal-trigger {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
  z-index: 1;
}
.hidden-modal-trigger :deep(.ant-btn) {
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
}
</style>
<style>
.vc-alpha-slider__bar,
.vc-alpha-slider.transparent {
  display: none !important;
}
.mr20px {
  margin-right: 20px;
}
</style>
